import { useRef, useEffect } from "react";

// Cursor-following crimson glow, mounted only while a card is hovered.
// CSS-only (no WebGL) so hovering across the auto-drifting Arsenal carousel
// never accumulates GPU contexts (which previously caused the background to
// go white after a while when the browser force-dropped WebGL contexts).
export default function CardRipple() {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const parent = el.parentElement;
    if (!parent) return;

    const onMove = (e) => {
      const r = parent.getBoundingClientRect();
      const x = ((e.clientX - r.left) / r.width) * 100;
      const y = ((e.clientY - r.top) / r.height) * 100;
      el.style.setProperty("--mx", `${x}%`);
      el.style.setProperty("--my", `${y}%`);
    };
    parent.addEventListener("pointermove", onMove, { passive: true });
    return () => parent.removeEventListener("pointermove", onMove);
  }, []);

  return (
    <div
      ref={ref}
      aria-hidden="true"
      data-testid="card-ripple"
      className="pointer-events-none absolute inset-0 rounded-2xl transition-opacity duration-300"
      style={{
        background:
          "radial-gradient(200px circle at var(--mx,50%) var(--my,50%), rgba(225,29,29,0.20), rgba(225,29,29,0.06) 40%, transparent 65%)",
        mixBlendMode: "screen",
      }}
    />
  );
}
